import { createSlice } from '@reduxjs/toolkit'
import { mapSocketFactory } from '../../../utils/socketFactory'

const initialState = {
  whiteboardActive: false,
  notificationActive: false,
  whiteboardId: null

}


const whiteboardSlice = createSlice({
  name: 'whiteboard',
  initialState,
  reducers: {
    setIsWhiteboardActive: (state, action) => {
      state.whiteboardActive = action.payload
    },
    setNotificationActive: (state, action) => {
      state.notificationActive = action.payload
    },
    setWhiteboardId: (state, action) => {
      state.whiteboardId = action.payload
    },

  }
})

export const {
  setIsWhiteboardActive,
  setNotificationActive,
  setWhiteboardId
} = whiteboardSlice.actions

export const CHECK_WHITEBOARD_STATUS = mapSocketFactory.emit('checkWhiteboardStatus', 'whiteboard/checkWhiteboardStatus')


export default whiteboardSlice.reducer